<mat-progress-bar [hidden]="!loading" mode="indeterminate"></mat-progress-bar>
<div class="container-fluid">
  <router-outlet></router-outlet>
</div>
